import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter as Router } from 'react-router-dom';

import { createStore , applyMiddleware} from 'redux'
import { Provider } from 'react-redux'
import promiseMiddleware from 'redux-promise-middleware';
import thunkMiddleware from 'redux-thunk';
import logger from 'redux-logger';


import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import './css/main.css';
import './css/app.css';
import './css/style.css';
import './css/oam.css';
import './css/fonts/icomoon/icomoon.css';

import AppCommHandler from './api/AppCommHandler';
import App from './App';
import reducer from './reducers'

const middleware = applyMiddleware(promiseMiddleware(),thunkMiddleware,logger)
const store = createStore(reducer,middleware)
AppCommHandler.setStore(store);
ReactDOM.render(<Provider store={store}><Router><App /></Router></Provider>, document.getElementById('wrap'));



